
document.addEventListener( 'DOMContentLoaded', () => {
  const tabButtons = Array.from( document.querySelectorAll( '.tab-slider-tab' ) );
  const sliderContainer = document.querySelector( '.tab-slider' );
  const tabsWrapper = document.getElementById( 'tab-slider-tabs' );
  const prevBtn = document.querySelector( '#tab-slider-controls .tns-prev' );
  const nextBtn = document.querySelector( '#tab-slider-controls .tns-next' );

  if ( !tabButtons.length || !sliderContainer || typeof tns !== 'function' ) return;

  const slider = tns( {
    container: sliderContainer,
    items: 1,
    slideBy: 1,
    controls: true,
    gutter: 8,
    prevButton: document.querySelector( '#tab-slider-controls .tns-prev' ),
    nextButton: document.querySelector( '#tab-slider-controls .tns-next' ),
    nav: false,
    loop: false,
    speed: 400,
    autoplay: false,
    mouseDrag: true,
  } );

  // Track horizontal offset for the entire tabs row (mobile only)
  let tabTranslateX = 0;

  function applyTabTransform () {
    if ( !tabsWrapper || window.innerWidth >= 1024 ) return; // only transform on mobile/tablet
    tabsWrapper.style.transition = 'transform 200ms ease';
    tabsWrapper.style.transform = `translateX(${ tabTranslateX }px)`;
  }

  const classesOf = ( el, attr ) => ( el.dataset[ attr ] || '' ).split( /\s+/ ).filter( Boolean );

  function setActiveTab ( index ) {
    tabButtons.forEach( ( btn, i ) => {
      if ( i === index ) {
        btn.classList.remove( ...classesOf( btn, 'inactiveClass' ) );
        btn.classList.add( ...classesOf( btn, 'activeClass' ), 'pointer-events-none', 'cursor-default' );
      } else {
        btn.classList.remove( ...classesOf( btn, 'activeClass' ), 'pointer-events-none',
          'cursor-default' );
        btn.classList.add( ...classesOf( btn, 'inactiveClass' ) );
      }
    } );
  }

  slider.events.on( 'indexChanged', info => {
    const realIndex = info.displayIndex - 1; // 1-based to 0-based
    setActiveTab( realIndex );
  } );

  tabButtons.forEach( ( btn, i ) => {
    btn.addEventListener( 'click', () => {
      slider.goTo( i );
      setActiveTab( i );
    } );
  } );

  // Pre-compute each tab's width so we can move by exact tab widths
  const tabWidths = tabButtons.map( btn => btn.offsetWidth );

  function moveTabsByIndex ( indexDelta ) {
    if ( !tabsWrapper || window.innerWidth >= 1024 ) return;

    const currentIndex = tabButtons.findIndex( btn => btn.classList.contains( 'cursor-default' ) );
    if ( currentIndex === -1 ) return;

    let targetIndex = currentIndex + indexDelta;
    if ( targetIndex < 0 ) targetIndex = 0;
    if ( targetIndex > tabButtons.length - 1 ) targetIndex = tabButtons.length - 1;

    const stepWidth = tabWidths[ targetIndex ] || 0;

    if ( indexDelta > 0 ) {
      // moving to the right (next tab), shift row left by that tab's width
      tabTranslateX -= stepWidth - 30;
    } else if ( indexDelta < 0 ) {
      // moving to the left (prev tab), shift row right by that tab's width
      tabTranslateX += stepWidth;
      if ( tabTranslateX > 0 ) tabTranslateX = 0; // don't overshoot right edge
    }

    applyTabTransform();
  }

  // --- Improved dynamic height adjustment for active slide ---
  const tabSliderItems = Array.from( document.querySelectorAll( '.tab-slider-item' ) );

  function setSliderContainerHeight () {
    if ( typeof slider.getInfo === 'function' ) {
      const info = slider.getInfo();
      const activeIndex = info.index;
      const activeSlide = tabSliderItems[ activeIndex ];
      if ( activeSlide && sliderContainer ) {
        sliderContainer.style.height = ( activeSlide.offsetHeight + 20 ) + 'px';
      }
    }
  }
  // Initial height
  setSliderContainerHeight();
  // On slide change
  slider.events.on( 'indexChanged', info => {
    setTimeout( setSliderContainerHeight, 10 ); // allow DOM update
  } );
  // On window resize
  window.addEventListener( 'resize', setSliderContainerHeight );
  // --- End improved dynamic height adjustment ---

  // On mobile, move the whole tab row by the active tab's width with prev/next
  if ( tabsWrapper && window.innerWidth < 1024 ) {
    if ( prevBtn ) {
      prevBtn.addEventListener( 'click', () => {
        moveTabsByIndex( -1 );
      } );
    }

    if ( nextBtn ) {
      nextBtn.addEventListener( 'click', () => {
        moveTabsByIndex( 1 );
      } );
    }
  }

  setActiveTab( 0 );
} );
